import * as React from "react"
import { Appearance, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { color } from "../../../theme"
import { FastField, FieldProps } from "formik"
import { FormControl, FormControlProps } from "../../form-control/form-control"
import { ModelPicker, ModelPickerProps } from "../../model-picker/model-picker"
import en from "../../../i18n/en"
import _ from "lodash"
import { TxKeyPath } from "../../../i18n"
import { FC, memo } from "react"
import { FastFieldProps } from "formik/dist/FastField"

export interface ModelFieldProps {
  FieldComponent?: React.ComponentType<any>,
  name: string,
  colorScheme?: "light" | "dark",
  txPrefix?: keyof typeof en,
  formControlProps?: FormControlProps,
  modelPickerProps?: (Omit<ModelPickerProps, "onValueChange"> & { onValueChange?: (value, index, item) => void })
}

const FORM_CONTROL: ViewStyle = {
  paddingHorizontal: 16,
  // marginBottom: 8,
  paddingBottom: 8,
  backgroundColor: color.palette.white
}

export const ModelFormControl: FC<Omit<ModelFieldProps, "FieldComponent">> = memo(function ModelFormControl(props) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    txPrefix,
    formControlProps, modelPickerProps,
    name
  } = props;

  const column = name.split('.').pop()

  return (<FormControl
    labelTx={(txPrefix && `${txPrefix}.${_.camelCase(column)}` as TxKeyPath) || undefined}
    colorScheme={colorScheme}
    labelColor={color.palette.gray800}
    style={FORM_CONTROL}
    {...formControlProps}
  >
    <ModelPicker
      testID={`jala:id/${name}-input`}
      colorScheme={colorScheme}
      placeholderTx={(txPrefix && `${txPrefix}.${_.camelCase(column)}Placeholder` as TxKeyPath) || undefined}
      isUseSearch
      {...modelPickerProps}
    />
  </FormControl>);
})

/**
 * Describe your component here
 */
export const ModelField = observer(function ModelField(props: ModelFieldProps) {
  const {
    FieldComponent = FastField,
    name, colorScheme = "light" || Appearance.getColorScheme(),
    formControlProps, modelPickerProps, ...restProps
  } = props

  return (
    <FieldComponent name={name}>
      {({ field, form: { setFieldValue, setFieldTouched }, meta }: (FastFieldProps | FieldProps)) => (
        <ModelFormControl
          name={field.name}
          colorScheme={colorScheme}
          formControlProps={{
            isInvalid: (meta.initialValue || meta.touched) && !!meta.error,
            errorMessage: meta.error,
            ...formControlProps,
          }}
          modelPickerProps={{
            value: field.value,
            async onValueChange(value) {
              await setFieldValue(field.name, value || null)
              await setFieldTouched(field.name)
            },
            ...modelPickerProps
          }}
          {...restProps}
        />
      )}
    </FieldComponent>
  )
})
